import(/* webpackMode: "eager", webpackExports: ["ConnectWallet"] */ "/vercel/path0/apps/ez-mining/src/components/ConnectWallet/index.tsx");
